export const people = [
	{
		username: 'ryan_maverick',
		name: 'Ryan',
		gallery: [
			'/images/6-1.png',
			'/images/6.png',
		],
		descriptions: 'Entrepreneur 🚀 | Dog lover 🐶 | Always looking for new ideas to explore!',
		interests: ['business', 'dogs', 'cycling'],
		gender: 'Male',
		genderOfInterest: 'Female',
		country: 'Germany',
		city: 'Berlin',
		birthday: '1998-09-10 15:40:50.327434',
		career: 'Startup Founder',
	    religion: 'Buddhist',
	    size: 169
	},
	{
		username: 'paula123',
		name: 'Paula',
		gallery: [
			'/images/1.png',
			'/images/1-1.png'
		],
		descriptions: 'Passionate about design and tech. Always up for a deep conversation over coffee. 🚀',
		interests: ['art', 'coding', 'travel'],
		gender: 'Female',
		genderOfInterest: 'Male',
		country: 'Ukraine',
		city: 'Kyiv',
		birthday: '2002-11-07 09:40:46.277434',
		career: 'UX Designer',
		religion: 'Christian',
	    questions: [
	      { title: 'Favorite movie?', description: 'Mad Max: Fury Road 🏎️🔥' },
	      { title: 'How do you relax?', description: 'Skydiving 😅' },
	      { title: 'If you could travel anywhere, where?', description: 'Antarctica! 🧊' },
	      { title: 'Dream job?', description: 'National Geographic Photographer 📷' }
	    ],
	    size: 160,
	    relationship: 'Single',
	    findGender: ['Male'],
	    findAge: [18, 20],
	    findFor: 'Friends',
	},
	{
		username: 'sofia_wander',
		name: 'Konstantin',
		gallery: [
			'/images/3.png',
			'/images/3-1.png'
		],
		descriptions: 'World traveler 🌍 | Book lover 📚 | Coffee addict ☕. Let’s explore life together!',
		interests: ['traveling', 'reading', 'yoga'],
		gender: 'Male',
		genderOfInterest: 'Male',
		country: 'Spain',
		city: 'Barcelona',
		birthday: '1997-07-21 10:30:24.927434',
		career: 'Travel Blogger',
	    religion: 'Atheist',
	    questions: [
	      { title: 'Favorite movie?', description: 'Interstellar 🌌' },
	      { title: 'Favorite music genre?', description: 'Indie Rock 🎸' },
	      { title: 'Do you believe in extraterrestrial life?', description: 'Absolutely, the universe is too big to be empty!' },
	      { title: 'Best way to spend a weekend?', description: 'Hiking in the mountains and stargazing.' },
	      { title: 'What inspires you?', description: 'The endless possibilities of the universe and human creativity.' }
	    ],
	    size: 190
	},
	{
		username: 'mark_99',
		name: 'Mark',
		gallery: [
			'/images/2.png',
			'/images/2-1.png',
			'/images/2-2.png'
		],
		descriptions: 'Fitness enthusiast 💪 | Love hiking, music, and coding. Let’s build something amazing together.',
		interests: ['gym', 'hiking', 'rock music'],
		gender: 'Male',
		genderOfInterest: 'Female',
		country: 'USA',
		city: 'Los Angeles',
		birthday: '1999-04-15 14:25:36.177434',
		career: 'Software Engineer',
	    size: 153
	},
	{
		username: 'james_code',
		name: 'James',
		gallery: [
			'/images/4.png'
		],
		descriptions: 'Full-time coder, part-time musician. 🎸💻 Love challenges and deep convos.',
		interests: ['coding', 'guitar', 'chess'],
		gender: 'Male',
		genderOfInterest: 'Female',
		country: 'UK',
		city: 'London',
		birthday: '1997-02-09 12:12:12.127434',
		career: 'Software Developer',
	    religion: 'Agnostic',
	    questions: [
	      { title: 'Favorite book?', description: '1984 by George Orwell 📖' },
	      { title: 'What’s your life motto?', description: '“We are all stardust.”' },
	      { title: 'Do you believe in fate?', description: 'More in free will than destiny.' }
	    ],
	    size: 190
	},
	{
		username: 'elena_fashion',
		name: 'Elena',
		gallery: [
			'/images/5.png',
			'/images/5-1.png'
		],
		descriptions: 'Fashion stylist & part-time photographer 📸. Love discovering new cultures!',
		interests: ['fashion', 'photography', 'travel'],
		gender: 'Female',
		genderOfInterest: 'Male',
		country: 'France',
		city: 'Paris',
		birthday: '2000-05-30 08:20:40.227434',
		career: 'Fashion Stylist',
	    religion: 'Atheist',
	    questions: [
	      { title: 'Favorite programming language?', description: 'JavaScript (obviously 😎)' },
	      { title: 'Best innovation of the last decade?', description: 'Decentralized finance 💰' },
	      { title: 'Would you upload your mind into a machine?', description: 'Depends on the backup options 😂' }
	    ],
	    size: 167
	},
	{
		username: 'nina_art',
		name: 'Nina',
		gallery: [
			'/images/7.png',
			'/images/7-1.png'
		],
		descriptions: 'Painter 🎨 | Dreamer 🌙 | Nature lover 🍃. Let’s make life a masterpiece.',
		interests: ['painting', 'nature walks', 'meditation'],
		gender: 'Female',
		genderOfInterest: 'Male',
		country: 'Italy',
		city: 'Rome',
		birthday: '2003-01-18 17:15:30.527434',
		career: 'Artist',
	    questions: [
	      { title: 'What inspires you?', description: 'Nature, emotions, and music.' },
	      { title: 'Favorite art movement?', description: 'Impressionism 🎨' },
	      { title: 'Dream collaboration?', description: 'A project with Studio Ghibli! ✨' }
	    ],
	    size: 173
	},
	{
		username: 'kevin_sports',
		name: 'Kevin',
		gallery: [
			'/images/8.png'
		],
		descriptions: 'Basketball player 🏀 | Fitness addict 💯 | Let’s talk sports and adventure!',
		interests: ['basketball', 'running', 'adventure'],
		gender: 'Male',
		genderOfInterest: 'Female',
		country: 'Canada',
		city: 'Toronto',
		birthday: '1995-06-23 19:30:10.627434',
		career: 'Athlete'
	},
	{
		username: 'zoe_dreamer',
		name: 'Zoe',
		gallery: [
			'/images/9.png'
		],
		descriptions: 'Dream big ✨ | Believe in kindness 💖 | Love cozy movie nights 🍿.',
		interests: ['movies', 'psychology', 'stargazing'],
		gender: 'Female',
		genderOfInterest: 'Male',
		country: 'Australia',
		city: 'Sydney',
		birthday: '2002-12-05 21:50:30.727434',
		career: 'Psychology Student',
	}
];

export const messages = [
	{
		username: 'zoe_dreamer',
		name: 'Zoe',
		gallery: [
			'/images/9.png'
		],
		createdAt: '2024-10-23T11:37:19.747Z'
	},
	{
		username: 'telegram',
		name: 'Emmy',
		gallery: [
			'/images/1-1.png'
		],
		createdAt: '2024-10-23T11:37:19.747Z'
	}
];

export const likeMe = [
	{
		gallery: [
			'/images/3.png'
		]
	},
	{
		gallery: [
			'/images/5.png'
		]
	}
];

export const groups = [
  {
    link: 'https://example.com/football-party',
    image: '/images/group-0.jpg',
    name: 'Football Party',
    description: 'Join us for an exciting football match screening with snacks, drinks, and great company!',
    tags: ['football', 'sports', 'party'],
    country: 'Canada',
    city: 'Toronto'
  },
  {
    link: 'https://example.com/book-club',
    image: '/images/group-3.png',
    name: 'The Book Lovers Club',
    description: 'A cozy book club for literature lovers. Monthly meet-ups with discussions on classics and bestsellers.',
    tags: ['books', 'literature', 'reading'],
    country: 'USA',
    city: 'New York'
  },
  {
    link: 'https://example.com/night-party',
    image: '/images/group-1.jpg',
    name: 'Weekend Night Party',
    description: 'The best nightlife experience in town! Live DJs, drinks, and an unforgettable atmosphere.',
    tags: ['party', 'nightlife', 'music'],
    country: 'Spain',
    city: 'Barcelona'
  },
  {
    link: 'https://example.com/business-psychology',
    image: '/images/group-2.jpg',
    name: 'Business Meetup',
    description: 'Networking event focused on psychology in business. Meet experts and discuss strategies.',
    tags: ['business', 'psychology', 'networking'],
    country: 'Germany',
    city: 'Berlin'
  },
  {
    link: 'https://example.com/street-football',
    image: '/images/group-4.png',
    name: 'Street Football Meetup',
    description: 'Casual football meetup for players of all levels. Bring your team or join one on the spot!',
    tags: ['football', 'outdoor', 'community'],
    country: 'UK',
    city: 'London'
  }
];

export const groupsLikeMe = [
  {
    link: 'https://example.com/business-psychology',
    image: '/images/group-2.jpg',
    name: 'Business Meetup',
    description: 'Networking event focused on psychology in business. Meet experts and discuss strategies.',
    tags: ['business', 'psychology', 'networking'],
    country: 'Germany',
    city: 'Berlin'
  },
  {
    link: 'https://example.com/street-football',
    image: '/images/group-4.png',
    name: 'Street Football Meetup',
    description: 'Casual football meetup for players of all levels. Bring your team or join one on the spot!',
    tags: ['football', 'outdoor', 'community'],
    country: 'UK',
    city: 'London'
  }
];

export const myGroups = [
  {
  	id: 1,
    link: 'https://example.com/business-psychology',
    image: '/images/group-2.jpg',
    newApprove: 2,
    name: 'Business Meetup',
    description: 'Networking event focused on psychology in business. Meet experts and discuss strategies.',
    tags: ['business', 'psychology', 'networking'],
    country: 'Germany',
    city: 'Berlin'
  },
  {
  	id: 2,
    link: 'https://example.com/street-football',
    image: '/images/group-4.png',
    name: 'Street Football Meetup',
    description: 'Casual football meetup for players of all levels. Bring your team or join one on the spot!',
    tags: ['football', 'outdoor', 'community'],
    country: 'UK',
    city: 'London'
  }
];

export const groupsApproved = [
  {
    link: 'https://example.com/business-psychology',
    image: '/images/group-2.jpg',
    name: 'Business Meetup',
    description: 'Networking event focused on psychology in business. Meet experts and discuss strategies.',
    tags: ['business', 'psychology', 'networking'],
    country: 'Germany',
    city: 'Berlin'
  },
  {
    link: 'https://example.com/street-football',
    image: '/images/group-4.png',
    name: 'Street Football Meetup',
    description: 'Casual football meetup for players of all levels. Bring your team or join one on the spot!',
    tags: ['football', 'outdoor', 'community'],
    country: 'UK',
    city: 'London'
  },
  {
    link: 'https://example.com/book-club',
    image: '/images/group-3.png',
    name: 'The Book Lovers Club',
    description: 'A cozy book club for literature lovers. Monthly meet-ups with discussions on classics and bestsellers.',
    tags: ['books', 'literature', 'reading'],
    country: 'USA',
    city: 'New York'
  },
  {
    link: 'https://example.com/night-party',
    image: '/images/group-1.jpg',
    name: 'Weekend Night Party',
    description: 'The best nightlife experience in town! Live DJs, drinks, and an unforgettable atmosphere.',
    tags: ['party', 'nightlife', 'music'],
    country: 'Spain',
    city: 'Barcelona'
  },
];